import { render, staticRenderFns } from "./ImportServiceList.vue?vue&type=template&id=52f2406f&"
import script from "./ImportServiceList.vue?vue&type=script&lang=js&"
export * from "./ImportServiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports